import { IJsonQuery } from '../../../../packages/api-models/common/json_query';

export enum EResultsStatus {
  Initial = 'initial',
  Loading = 'loading',
  Succeed = 'succeed',
  Failed = 'failed',
}

export interface IResultsState {
  status: EResultsStatus;
  version?: symbol;
  dominantSubdomain: string;
  dominantRegionId: number | null;
  jsonQuery: IJsonQuery;
  sortedOfferIds: number[];
  offersCount: number;
}
